import { Cirus } from "@/classes/Http";
class Body {
    constructor(public Amount: number, public account_id: string) {}
}

export function withdrawUserMoney(params: Body) {
    const path = `/user/withdrawal/`;
    return Cirus.put(path, params);
}